import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import { ChartTemplate } from "../chartTemplate";

/* 
dc chart instance 
returns value chains chart
*/
const vcChartFun = (divRef, ndx) => {
  // create dimension by dimension
  var valueChains = ndx.dimension((d) => {
    return d.valueChains;
  });

  /* create a select menu chart widgets */
  const vcChart = dc.selectMenu(divRef);
  vcChart
    .dimension(valueChains) /* pass the dimension */
    .group(valueChains.group()) /* pass the grouped data by dimension */
    .on("filtered", function (chart, filter) {
      var sel = chart.filterPrinter()(chart.filters());
      window.MVALUECHAIN = sel
      //console.log("selected filters are:" + sel);
    }) /*  for testing -  check if the event listener is working */
    .title(function (d) {
      return d.key;
    }) /* the select menu drop down value */
     /*  for testing -  check if the event listener is working */
    .controlsUseVisibility(true); /*  enable chart  interactivity */
  return vcChart;
};

export const ValueChainChart = (props) => (
  <ChartTemplate /*  pass the chart fuc for rendering */
    chartFunction={vcChartFun}
    name="Select Value Chain" /*  chart display  title */
  />
);
